import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { ITimelineColumnProps } from "src/components/Planner/TimelineColumn/TimelineColumn";
import { UnstyledButton } from "src/ui";
import { Callout } from "@fluentui/react";
import TimelineLabelForm from "src/components/Planner/TimelineLabelForm/TimelineLabelForm";
import { CaptionBody, MediumBody, SmallBody } from "src/components/Text";
import { localize } from "src/l10n";
import { dayLangTags, monthLangTags } from "../utils";

const isMiddleOfMonth = (m: any) => {
    const daysInMonth = m.daysInMonth();
    const middleDay = Math.ceil(daysInMonth / 2);
    return m.date() === middleDay;
}

const TimelineColumnWeek = (props: ITimelineColumnProps) => {
    const headerRef = React.useRef<HTMLDivElement>(null);

    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            isThursday: m.isoWeekday() === 4,
            isSunday: m.isoWeekday() === 7,
            isFirstOfMonth: m.date() === 1,
            dateIsMiddleOfTheMonth: isMiddleOfMonth(m),
            weekDayChar: localize(dayLangTags[m.isoWeekday() - 1])[0],
            dateNumber: m.format("D"),
            momentDate: m,
            isoWeekday: m.isoWeekday(),
            isActive: m.isSame(moment(), 'day')
        }
    }, [props.item.startMilliseconds]);

    const [displayCallout, setDisplayCallout] = useState(false);

    useEffect(() => {
        props.reportHeaderHeight(headerRef.current.clientHeight);
    }, [headerRef, props.displayLabelRow]);

    return (
        <div className="TimelineColumn" style={{
            width: props.columnWidth
        }}>
            <div ref={headerRef}>
                <div
                    className={[
                        "header-column",
                        data.isFirstOfMonth ? "border-left" : "",
                    ].filter(x => !!x).join(" ")}
                    style={{
                        height: 32,
                        width: props.columnWidth,
                    }}>
                    <SmallBody color="gray">{data.dateIsMiddleOfTheMonth && (localize(monthLangTags[data.momentDate.month()]) + " " + data.momentDate.format("YYYY"))}</SmallBody>
                </div>
                <div
                    className={[
                        "header-column",
                        data.isSunday ? "border-right" : "",
                    ].filter(x => !!x).join(" ")}
                    style={{
                        height: 32,
                        width: props.columnWidth,
                    }}>
                    <SmallBody>{data.isThursday && (localize("Vecka") + " " + data.momentDate.isoWeek())}</SmallBody>
                </div>
                {props.displayLabelRow && (
                    <UnstyledButton
                        className="header-column border-right label"
                        disabled={!props.rights.canEditLabels}
                        style={{
                            width: props.columnWidth
                        }}
                        onClick={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    >
                        <CaptionBody weight="medium">{props.label?.text}</CaptionBody>
                    </UnstyledButton>
                )}
                <UnstyledButton
                    id={"column-" + props.item.startMilliseconds}
                    disabled={!props.rights.canEditLabels}
                    className={[
                        "header-column",
                        "border-right",
                        "date",
                        (data.isActive ? " active" : "")
                    ].join(" ")}
                    style={{
                        width: props.columnWidth,
                        height: 36,
                    }}
                    onClick={() => {
                        setDisplayCallout(!displayCallout);
                    }}
                >
                    <div>
                        <SmallBody color="gray">{data.weekDayChar}</SmallBody>
                        <SmallBody>{data.dateNumber}</SmallBody>
                    </div>
                </UnstyledButton>
                {displayCallout && (
                    <Callout
                        preventDismissOnResize
                        role="alertdialog"
                        gapSpace={0}
                        setInitialFocus
                        onDismiss={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                        className="users-selection"
                        target={"#column-" + props.item.startMilliseconds}
                    >
                        <TimelineLabelForm
                            date={new Date(props.item.startMilliseconds)}
                            onDone={() => {
                                setDisplayCallout(!displayCallout);
                            }}
                        />
                    </Callout>
                )}
            </div>
            <div className={[
                "border-right",
                "lane",
                "weekday-" + data.isoWeekday
            ].join(" ")} style={{
                width: props.columnWidth,
            }}></div>
        </div>
    )
}

export default TimelineColumnWeek;
